// removed by extract-text-webpack-plugin
module.exports = {"text":"fr_fs","homepageContainer":"fr_ft","container":"fr_g fr_ft","heading":"fr_i","homepageHeading":"fr_fu","content":"fr_bt","homepageContent":"fr_fv fr_bt","link":"fr_cx","right":"fr_fw fr_cx","flex":"fr_fx","block":"fr_r fr_fx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/SignUpPrompt/styles.module.css
// module id = 1153
// module chunks = 27